import anime from 'animejs';

const tableItem = (el) => {
  const anim = anime({
    targets: el.node,
    duration: 600,
    opacity: [0, 1],
    translateY: [20, 0],
    easing: [0.25, 0.87, 0.43, 1],
    onComplete: () => {
      el.node.removeAttribute('js-anim');
    }
  });

  return anim;
};

export default tableItem;
